<template>
  <div id="app_signup">
    <v-snackbar v-model="showsnackbar" color="#00a972" right :timeout="timeout">
      {{msg}}
      <v-btn text @click="showsnackbar = false">
        <v-icon style="color:white;">mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-layout wrap justify-space-around>
      <v-flex xs12 md12 pa-0>
        <v-layout wrap justify-center>
          <v-flex xs12 sm12 md12>
            <Projects />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import Projects from "./../ProjectStatus/projects";

export default {
  props: ["id"],
  components: {
    Projects
  },
  data() {
    return {
      showsnackbar: false,
      timeout: 5000,
      msg: null
    };
  }
};
</script>
<style scoped>
#app_signup {
  background-image: url("../../assets/home_header.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  color: white;
}
@media only screen and (min-width: 800px) {
  #app_height {
    min-height: 80vh;
  }
}
</style>